module.exports = __webpack_public_path__ + "components/MapControl/svg/Fontanna.svg?937a1077";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Fontanna.svg
// module id = 1926
// module chunks = 0